import { axiosCore } from './http-core-service';
import { FinanceType } from './dtos/finances.dto';
import { RelationType } from './dtos/relation.dto';

type RemoteFileDto = {
    file: string;
    fileName: string;
};

type FinanceRequestResponseDto = {
    status?: number | string;
};

/**
 * Récupération de la liste des impayés dans les finances du mandat.
 * @param mandateId identifiant du mandat
 * @param type
 */
export const getFinancesFile = async (mandateId: string, type: FinanceType | RelationType): Promise<RemoteFileDto> => {
    let criterion = '';
    switch (type) {
        case FinanceType.BASHBOARD:
            criterion = 'dashboard';
            break;
        case FinanceType.ADMISSION:
            criterion = 'admission';
            break;
        case FinanceType.UNPAID:
            criterion = 'unpaid';
            break;
        case FinanceType.DEBT:
            criterion = 'debt';
            break;
        default:
            break;
    }
    // Récupération du doc selon le mandat
    const response = await axiosCore.get(`/api/finances/mandate/${mandateId}/${criterion}/document`);
    return response.data;
};

/**
 * Demande de récupération des documents
 * @param mandateId
 * @param type
 */
export const askFinanceFile = async (
    mandateId: string,
    type: FinanceType | RelationType
): Promise<FinanceRequestResponseDto> => {
    let criterion = '';
    // Gestion du critère de finance à envoyer dans le body
    switch (type) {
        case FinanceType.BASHBOARD:
            criterion = 'dashboard';
            break;
        case FinanceType.ADMISSION:
            criterion = 'admission';
            break;
        case FinanceType.UNPAID:
            criterion = 'unpaid';
            break;
        case FinanceType.DEBT:
            criterion = 'debt';
            break;
        default:
            break;
    }
    // Création d'un json pour la requête
    const data = {
        typeFinance: criterion,
    };

    // Récupération du doc selon le mandat
    const response = await axiosCore.post(`/api/finances/mandate/${mandateId}/request`, data);
    return response.data;
};
